<div id='drawer-order'>
  <dx-scroll-view class="dx-card">
    <section class='order-header dx-card'>
      <h3>Order {{order.codeValue}} Results</h3>
      <span [innerHTML]='Status'></span>
      <span class='spacer'></span>
      <dx-button icon='edit' hint='Edit' style='margin-right: 4px' (onClick)='sendToPreview()'></dx-button>
      <dx-button icon='close' hint='Close' (onClick)='closeEvent.next()'></dx-button>
    </section>
    <section #top class='order-common-information'>
      <app-order-header fxShow fxHide.lt-md [patient]="OrderPatient" [physician]="OrderPhysician" [order]="order"
                        [client]="order.patientClient"></app-order-header>
    </section>
    <section>
      <section *ngIf='order && order.reportComment' class='ocl-container-with-padding' style='width: 100%'>
        <div>
          <h4>Order Comments</h4>
          <div fxLayout='row' fxLayoutAlign='space-between'>
          </div>
        </div>
        <div fxLayout='row' fxLayoutAlign='space-between' style='height: 80px'>
          <dx-html-editor [width]="'100%'" valueType='html' [value]="order ? order.reportComment : ''"
                          [disabled]='true'>
          </dx-html-editor>
        </div>
      </section>
      <section *ngIf='order && CancellationReasons' class="ocl-container-with-padding" style="width: 100%">
        <div>
          <h4>Cancellation Reasons</h4>
          <div fxLayout="row" fxLayoutAlign="space-between">
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between" style="height: 80px">
          <dx-html-editor [width]="'100%'" valueType="html" [value]="CancellationReasons"
                          [disabled]="true">
          </dx-html-editor>
        </div>
      </section>
      <section class='ocl-container-with-padding'>
        <dx-tab-panel
          [dataSource]="[
                            { id: 1, title: 'Clinical Results', template: 'clinicalResults', visible: clinicalResultsVisible },
                            { id: 2, title: 'Microbiology Results', template: 'microbiologyResults', visible: microbiologyResultsVisible },
                            { id: 3, title: 'Toxicology Results', template: 'toxicologyResults', visible: toxicologyResultsVisible },
                            { id: 4, title: 'Pathology Results', template: 'pathologyResults', visible: pathologyResultsVisible }
                        ]"
          [selectedIndex]="selectedTab"
          [loop]="false"
          [animationEnabled]="true"
          [swipeEnabled]="false"
          style="padding-bottom: 16px; width: 100%"
        >
          <div *dxTemplate="let results of 'clinicalResults'" style="height: 100%; overflow: hidden">
            <div *ngIf="clinicalResultsVisible" style="height: 100%; overflow: hidden">
              <app-clinical-results [orderId]="orderId"></app-clinical-results>
            </div>
          </div>
          <div *dxTemplate="let results of 'toxicologyResults'" >
            <div *ngIf="toxicologyResultsVisible" style="height: 100%; overflow: hidden">
              <app-toxicology-results [orderId]="orderId"
                                      (hasUnexpectedPositive)="hasToxicologyUnexpectedPositiveResults($event)">
              </app-toxicology-results>
            </div>
          </div>
          <div *dxTemplate="let results of 'microbiologyResults'" style="height: 100%; overflow: hidden">
            <div *ngIf="microbiologyResultsVisible" style="height: 100%; overflow: hidden">
              <app-microbiology-results [orderId]="orderId"></app-microbiology-results>
            </div>
          </div>
          <div *dxTemplate="let results of 'pathologyResults'" style="height: 100%; overflow: hidden">
            <div *ngIf="pathologyResultsVisible" style="height: 100%; overflow: hidden">
              <app-pathology-results [orderId]="orderId" [isCancelled]="IsCancelled"></app-pathology-results>
            </div>
          </div>
        </dx-tab-panel>
      </section>
    </section>

    <div class="back-to-top-wrapper">
    <a class="back-to-top-link dx-card" aria-label="Scroll to Top" hint='Go up' (click)='scrollTo(top)'>
      <i class='fas fa-arrow-up'></i>
    </a>
    </div>
  </dx-scroll-view>
  <dx-load-panel
    shadingColor='rgba(0,0,0,0.4)'
    [(visible)]='isLoading'
    [showIndicator]='true'
    [showPane]='true'
    [shading]='true'
    [closeOnOutsideClick]='false'>
  </dx-load-panel>
</div>
